var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._t("pager"), _vm._v(" "), _c('div', {
    class: _vm.getClasses['wrapper'],
    attrs: {
      "id": "fullscreen-wrapper"
    },
    on: {
      "click": _vm.onClickOutsideModelContent
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.getClasses['modal'],
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "fullscreen-mod"
    },
    on: {
      "click": _vm.onClickOutsideModelContent
    }
  }, [_c('div', {
    class: _vm.getClasses['tableWrapper']
  }, [_c('div', {
    staticClass: "full-screen-div"
  }, [_vm.open ? _c('header', {
    staticClass: "modal-header full-screen-header",
    attrs: {
      "id": "close-pickup-modal___BV_modal_header_"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "close-fullscreen-header_text"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.headerText) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function ($event) {
        return _vm.openContent(!_vm.open);
      }
    }
  }, [_vm._v("\n            ×\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.getClasses['contentPad']
  }, [_c('div', {
    staticClass: "top-grid"
  }, [_c('div', {
    staticClass: "flex-left"
  }, [_vm._t("topleft")], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-right"
  }, [_vm._t("topright"), _vm._v(" "), _c('VActionButton', {
    attrs: {
      "label": _vm.open ? 'Close' : 'Expand',
      "show-icon": false,
      "show-badge": false
    },
    on: {
      "click": function ($event) {
        return _vm.openContent(!_vm.open);
      }
    }
  })], 2)]), _vm._v(" "), _vm._t("default")], 2)])])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }